import React from "react";
import { ShieldCheck, Award, TrendingUp, GraduationCap, Headphones, Smartphone } from "lucide-react";
import { SRETRADE_REGISTER } from "../mock";

const reasons = [
  {
    icon: ShieldCheck,
    title: "37 Yıllık Güven",
    text: "1988'den bu yana sermaye piyasalarında köklü deneyim ve SPK lisansı ile yatırımcılarımızın yanındayız.",
  },
  {
    icon: Award,
    title: "Uygun Komisyon",
    text: "Hisse Senedi ve VİOP işlemlerinde sektörün en rekabetçi komisyon oranlarını sunuyoruz.",
  },
  {
    icon: TrendingUp,
    title: "Uzman Araştırma",
    text: "Tecrübeli analiz kadromuzun her gün hazırladığı bültenler ve raporlar ile bilinçli kararlar alın.",
  },
  {
    icon: Smartphone,
    title: "Güçlü Platformlar",
    text: "Web, mobil ve profesyonel terminal platformlarımız ile her yerden hızlı ve güvenli işlem.",
  },
  {
    icon: GraduationCap,
    title: "Ücretsiz Eğitim",
    text: "Yatırımcı eğitim programlarımız ve canlı piyasa söyleşileri ile bilginizi sürekli geliştirin.",
  },
  {
    icon: Headphones,
    title: "Kişisel Destek",
    text: "Müşteri temsilcimiz ve VİOP uzmanlarımız ile birebir destek alın, sorularınız hızla yanıtlansın.",
  },
];

const WhyAcar = () => {
  return (
    <section className="bg-white">
      <div className="max-w-[1280px] mx-auto px-4 py-20">
        <div className="text-center mb-14">
          <span className="inline-block text-[12px] tracking-[0.25em] font-semibold text-[#1c4d9c] mb-3">
            NEDEN BİZ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Neden Acar Menkul?
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto leading-relaxed">
            37 yıllık tecrübe ve birikimin sağladığı güvenle yatırımcılarımıza en
            üst düzey hizmeti sunmayı amaçlıyoruz.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r, i) => (
            <div
              key={i}
              className="lift-on-hover relative bg-white border border-slate-200 rounded-xl p-7 group"
            >
              <div
                className="w-14 h-14 rounded-lg flex items-center justify-center mb-5 text-white"
                style={{
                  background: "linear-gradient(135deg, #2f6bc8 0%, #1c4d9c 100%)",
                }}
              >
                <r.icon className="w-7 h-7" />
              </div>
              <h3 className="font-bold text-lg text-slate-900 mb-2">{r.title}</h3>
              <p className="text-slate-600 text-sm leading-relaxed">{r.text}</p>
              <div className="absolute top-5 right-5 text-[44px] font-bold text-slate-100 leading-none select-none pointer-events-none">
                0{i + 1}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={SRETRADE_REGISTER}
            target="_blank"
            rel="noreferrer"
            className="inline-block px-8 py-3 rounded-md bg-[#e23a3a] hover:bg-[#c52d2d] text-white font-semibold transition shadow-sm"
          >
            Hemen Hesap Aç
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhyAcar;
